import useValueListData from "../../hooks/valuelist"

interface ICvtProps {
  list: string
  code: string
  appendText?: string
  prependText?: string
  noWhiteSpaceAppendText?: string
}

const Cvt = (props: ICvtProps) => {
  const value = useValueListData(props.list, props.code)

  return (
    <>
      {props?.prependText ? ` ${props.prependText}` : ""}
      {value}
      {props?.appendText ? ` ${props.appendText}` : ""}
      {props?.noWhiteSpaceAppendText ? props.noWhiteSpaceAppendText : ""}
    </>
  )
}

export default Cvt
